import axios from 'axios'
import {host,local} from '../vue.config'

export function queryProductByType(param) {
  return axios.get(local + '/public/queryProductByType',{params:param});
}




// WEBPACK FOOTER //
// ./src/services/commericalService.js